/*
 * Copyright 2024 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import KeyvRedis from '@keyv/redis';
import { Instance } from './types';
import { attemptKeyvConnection, startRedisLikeContainer } from './helpers';

const createStore = (connection: string) => new KeyvRedis(connection);

export async function connectToExternalRedis(
  connection: string,
): Promise<Instance> {
  const keyv = await attemptKeyvConnection(createStore, connection, 'redis');
  return {
    store: 'redis',
    connection,
    keyv,
    stop: async () => await keyv.disconnect(),
  };
}

export async function startRedisContainer(image: string): Promise<Instance> {
  return startRedisLikeContainer(image, 'redis', createStore);
}
